<template>
  <div id="tour-students-admit-form" class="w-full mb-10 space-y-3">
    <!-- Slim intro hint -->
    <div
      class="rounded-lg border border-primary/15 bg-primary/5 px-3 py-2 flex items-center gap-2 text-xs md:text-sm text-gray-600"
    >
      <i class="pi pi-info-circle text-primary text-sm shrink-0"></i>
      <span class="min-w-0">
        Fill in details and assign a {{ isTertiary ? 'level' : labels.CLASS.toLowerCase() }}.
        For many {{ labels.STUDENT.toLowerCase() }}s at once, use the
        <span class="font-medium text-primary">Import</span> tab.
      </span>
    </div>

    <StudentDetailsForm />
  </div>
</template>

<script setup lang="ts">
import StudentDetailsForm from './StudentDetailsForm.vue';
import { useSchoolLabels } from '@/composables/useSchoolLabels';
import { useSchoolFeatures } from '@/composables/useSchoolFeatures';

const { labels } = useSchoolLabels();
const { isTertiary } = useSchoolFeatures();
</script>
